// Packages and components
import React, { useState } from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDContainer from '@ui/Container/SHDContainer';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import SHDInput from '@ui/Input/SHDInput';

// Helpers and utilities
import { useGetCustomClaims } from '@hooks/useAdmin';

const GetCustomClaims: React.FC = () => {
  // State
  const [uid, setUid] = useState<string>('');

  // Hooks
  const { getCustomClaims, customClaims, loading, error } =
    useGetCustomClaims();

  // Handlers
  const handleInputChange = (input: string) => {
    setUid(input);
  };

  return (
    <SHDThemeOverride>
      <SHDContainer maxWidth="medium">
        <Box gap="medium">
          <SHDHeading level="3">Get Custom Claims</SHDHeading>
          <Box gap="large">
            <SHDInput label="Firebase Auth UID" onChange={handleInputChange} />
            <SHDButton
              primary
              label="Get Custom Claims"
              busy={loading}
              onClick={() => {
                getCustomClaims(uid);
              }}
            />
          </Box>
        </Box>

        {customClaims && (
          <Box gap="medium" margin={{ top: 'xxlarge' }}>
            <pre>{JSON.stringify(customClaims, null, 2)}</pre>
          </Box>
        )}

        {error && (
          <Box gap="medium">
            <SHDHeading level="3">Error</SHDHeading>
            <SHDText>{error.message}</SHDText>
          </Box>
        )}
      </SHDContainer>
    </SHDThemeOverride>
  );
};

export default GetCustomClaims;
